import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

class ImageSlider {
	constructor(el) {
		this.root = el;
		this.refreshLightbox = ::this.refreshLightbox;
		this.initSlider();
	}

	refreshLightbox() {
		window.glightbox.reload();
	}

	initSlider() {
		this.imageAndCopySlider = new Swiper(this.root.querySelector('.js-imageSliderContainer'), {
			spaceBetween: 1,
			slidesPerView: 1,
			loopAdditionalSlides: 1,
			resistanceRatio: 0,
			grabCursor: true,
			loop: Array.from(this.root.querySelectorAll('.swiper-slide')).length > 1,
			slideActiveClass: 'is-active',

			on: {
				slideChangeTransitionEnd: this.refreshLightbox,
			},

			navigation: {
				nextEl: this.root.querySelector('.js-imageSliderArrowNext'),
				prevEl: this.root.querySelector('.js-imageSliderArrowPrev'),
			},

			pagination: {
				el: this.root.querySelector('.js-imageSliderBulletList'),
				bulletElement: 'li',
				bulletClass: 'image-slider__bullet-item',
				bulletActiveClass: 'is-active',
				clickable: true,
			},

			breakpoints: {
				768: {
					spaceBetween: 1,
				},
				1256: {
					spaceBetween: 100,
				},
			},
		});
	}
}

Array.from(document.querySelectorAll('.js-imageSlider')).forEach(el => new ImageSlider(el));
